export default {
    namespaced: true,
    state: {
      selectedAdmissionFormId: null,
    },
    mutations: {
        SET_ADMISSION_FORM_ID(state, value) {
        state.selectedAdmissionFormId = value;
      }
    }
};